import {AvatarGroup} from '@sollapay/ui/components';

import {MemberAvatar} from './MemberAvatar';

import type {MemberAvatarProps} from './MemberAvatar';
import type {TeamPerson} from '../types';
import type {FC} from 'react';

export interface TeamAvatarStackProps {
  members: TeamPerson[];
  size: MemberAvatarProps['size'];
}

/** The team as overlapping avatars; `AvatarGroup` caps the stack and adds the `+N` chip. */
export const TeamAvatarStack: FC<TeamAvatarStackProps> = ({members, size}) => (
  <AvatarGroup size={size}>
    {members.map(member => (
      <MemberAvatar key={member.userId} user={member} size={size} />
    ))}
  </AvatarGroup>
);
